import { render, staticRenderFns } from "./DashboardMadrillas.vue?vue&type=template&id=9d5e6488&scoped=true"
import script from "./DashboardMadrillas.vue?vue&type=script&lang=js"
export * from "./DashboardMadrillas.vue?vue&type=script&lang=js"
import style0 from "./DashboardMadrillas.vue?vue&type=style&index=0&id=9d5e6488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5e6488",
  null
  
)

export default component.exports